<template lang="pug">
SspLayout(area="core")
  template(slot="actions")
    router-link.edit-button.btn.btn-default(:to="{name: 'productEdit', params: {id: productId}}" title="Edit")
      i.fa.fa-edit
      span.ml5 Edit
    button.edit-permissions-button.btn.btn-default(v-visible-for="['ROLE_PRODUCT_MANAGER']" @click="showPermissionsDialog()" title="Permissions")
      i.fa.fa-group
      span.ml5 Permissions
    router-link.edit-metadata-button.btn.btn-default(v-visible-for="['ROLE_PRODUCT_MANAGER']" :to="{name: 'productMetadata', params: {productId}}" title="Metadata")
      i.fa.fa-code
      span.ml5 Metadata
    button.delete-button.btn.btn-danger(v-visible-for="['ROLE_PRODUCT_MANAGER']" @click="removeProduct()" title="Remove")
      i.fa.fa-times
      span.ml5 Remove

  ProductDetails(:product="product")
  Permissions(ref="permissions")
</template>

<script>
import miniToastr from 'mini-toastr'
import Masterdata from '@/service/apis/Masterdata'
import Permissions from '@/components/ssp/Permissions'
import ProductDetails from './ProductDetails'

export default {
  data: () => ({
    product: {}
  }),
  created() {
    if (this.productId) {
      this.getProduct()
    }
  },
  methods: {
    getProduct() {
      Masterdata.getProduct(this.productId)
        .then((resp) => {
          this.product = resp.data
        })
        .catch((e) => { this.$emit('error', e) })
    },
    showPermissionsDialog() {
      this.$refs.permissions.open('PRODUCT', this.productId)
    },
    removeProduct() {
      this.$confirm({ text: 'Are you sure you want to remove this product?' })
        .then((conf) => {
          if (conf) {
            Masterdata.deleteProduct(this.productId)
              .then(() => {
                miniToastr.success('Product was successfully removed')
                this.$router.push('/core/configuration/products')
              })
              .catch((e) => {
                this.$emit('error', e)
              })
          }
        })
    }
  },
  computed: {
    productId() {
      return parseInt(this.$route.params.id, 10)
    }
  },
  components: {
    Permissions,
    ProductDetails
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/core/configuration/product/Product.vue